import * as constants from './sideNavBar.constants';

export function toggleCollapse(itemKey, mode) {
  return {
    type: constants.TOGGLE_COLLAPSE,
    [constants.ITEM_KEY]: itemKey,
    [constants.ITEM_COLLAPSE]: mode
  };
}
